import React, { StatelessComponent } from 'react';
import classNames from 'classnames';
import styles from './tag.styl';

export interface TagProps {
  label: string;
  value: string;
  onClick?: (value: string) => void;
}

export type TagComponent = StatelessComponent<TagProps>;

export const Tag: TagComponent = ({ label, value, onClick }) => (
  <label
    className={classNames(styles.root)}
    onClick={() => {
      if (onClick) {
        onClick(value);
      }
    }}
  >
    <span className={classNames(styles.tag)}>{label}</span>
  </label>
);
